import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import ProductManagement from '../../components/admin/ProductManagement';

const ProductsPage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <ProductManagement />
    </SuperAdminLayout>
  );
};

export default ProductsPage;
